"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundBleep = void 0;
class SoundBleep {
  constructor() {
    this.audio = document.createElement('audio');
    let source = document.createElement('source');
    if (this.audio.canPlayType('audio/mpeg;')) {
      source.type = 'audio/mpeg';
      source.src = 'appchat/highlight.mp3';
    } else {
      source.type = 'audio/ogg';
      source.src = 'appchat/highlight.ogg';
    }
    this.audio.appendChild(source);
  }
  play() {
    // audio.play() renvoie une promesse qui est REJETÉE si le navigateur bloque
    // la lecture automatique (mobile sans interaction préalable de l'utilisateur).
    // Sans ce catch, la promesse rejetée remonte en « Uncaught runtime error »
    // (ex. à la réception d'un MP en arrière-plan sur mobile). On l'ignore : le
    // son se jouera une fois que l'utilisateur aura interagi avec la page.
    let playPromise = this.audio.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }
}
exports.SoundBleep = SoundBleep;